export const TREE_DEPTH_STEP_PX = 22;
export const TREE_GUIDE_CHEVRON_CENTER_OFFSET = 17;

export function treeGuideLineLeft(level: number, checkboxShift = 0): number {
  return level * TREE_DEPTH_STEP_PX + TREE_GUIDE_CHEVRON_CENTER_OFFSET + checkboxShift;
}
